export default "__VITE_ASSET__BmrEaAbD__"